<template>
  <div class="year-filter">
    <div v-if="years.length === 0" class="empty-msg">
      Nincs évhez köthető réteg.
    </div>
    <label
      v-for="year in years"
      :key="year"
      class="year-row"
      :class="{ 'year-row--active': isActive(year) }"
    >
      <input
        type="checkbox"
        class="year-check"
        :checked="selectedYears.has(year)"
        @change="toggle(year)"
      />
      <span class="year-text">{{ year }}</span>
    </label>
    <p v-if="years.length > 1" class="year-hint">
      Jelölj ki egy vagy több évet a rétegek szűréséhez.
    </p>
  </div>
</template>

<script setup lang="ts">
import { useLayerSelection } from '@/composables/useLayerSelection'

defineProps<{
  /** Sorted list of selectable years (newest first) */
  years: number[]
}>()

const { selectedYears, setSelectedYears } = useLayerSelection()

function isActive(year: number) {
  return selectedYears.value.has(year)
}

function toggle(year: number) {
  const next = new Set(selectedYears.value)
  if (next.has(year)) {
    next.delete(year)
    // All unchecked → treat as "all years visible" (empty set)
    setSelectedYears(next.size === 0 ? new Set() : next)
  } else {
    next.add(year)
    setSelectedYears(next)
  }
}
</script>

<style scoped>
.year-filter {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 4px 2px;
}
.empty-msg { font-size: 12px; color: #585b70; padding: 16px 8px; text-align: center; }
.year-row {
  display: flex;
  align-items: center;
  gap: 9px;
  cursor: pointer;
  padding: 7px 10px;
  border-radius: 6px;
  border: 1px solid transparent;
  transition: background 0.15s, border-color 0.15s;
}
.year-row:hover { background: rgba(137,180,250,0.08); }
.year-row--active {
  background: rgba(166,227,161,0.12);
  border-color: rgba(166,227,161,0.3);
}
.year-check { accent-color: #a6e3a1; cursor: pointer; }
.year-text { font-size: 13px; font-weight: 500; color: #cdd6f4; }
.year-hint { font-size: 11px; color: #585b70; margin: 6px 2px 0; line-height: 1.4; }
</style>
